export const rootSelector = state => state;